// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles_slider__q4dCz","grabbing":"styles_grabbing__lEvVD"};